/* -----------------------------------------------------------------------------------------------------
  - Created: [14-02-2025] by [SREERAJ]
  - Modified: [02-05-25] 
  - Description: This file contains sites listing 
  -------------------------------------------------------------------------------------------------------
*/
import React, { useEffect, useState } from 'react';
import CustomAddButton from '../../../../Components/custom_components/CustomAddButton/CustomAddButton';
import './WorksiteSearchStyle.css';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import Grid from '@mui/material/Grid2';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import { useFormik } from 'formik';
import { get_worksite_with_out_pagination } from '../../../../config/Worksite/siteApis';
import { get_project_with_out_pagination } from '../../../../config/Worksite/projectApis';
import { statusOptions } from '../../../../utils/constants';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';
import { get_workforce_with_pagination } from '../../../../config/Resource/workforceApis';

function WorksiteSearch({ isAddPermission, tableTitle, isAddEdiModalOpen, handleAddEditModal, searchFilter, on_change_value, on_page_count_update }) {

    const [projectListing, SetProjectListing] = useState([]);
    const [siteListing, setSiteListing] = useState([]);
    const [workforceListing, setWorkforceListing] = useState([]);

    // FETCH PROJECTS
    const fetchProjects = async () => {
        try {
            const response = await get_project_with_out_pagination();
            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.ProjectName,
                    value: item?.ProjectID
                }));

                // Set the transformed data to the state
                SetProjectListing(transformedData || []);
            } else {
                SetProjectListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            SetProjectListing([]);
        }
    };

    // FETCH WORKSITES 
    const fetchSites = async () => {
        try {
            const response = await get_worksite_with_out_pagination();

            if (response?.status === "success") {
                const transformedData = response.data.data
                    ?.filter(item => item?.ParentWorksiteCode !== null) //addded by sreeraj 6/5/25 for filter by subsite
                    .map(item => ({
                        label: item?.worksiteName,
                        value: item?.WorksiteID
                    }));

                // Set the transformed data to the state
                setSiteListing(transformedData || []);
            } else {
                setSiteListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setSiteListing([]);
        }
    };

    // FETCH fetchWorkforce
    const fetchWorkforce = async () => {
        try {
            const params = { //FOR GET Superviosrs ONLY LIST
                RoleID: 2,
                status: ''
            }
            const response = await get_workforce_with_pagination(params);

            if (response?.status === "success") {
                // Transform data into the desired format with label and value
                const transformedData = response.data.data?.map((item) => ({
                    label: item?.UD_name,
                    value: item?.UD_ID
                }));

                // Set the transformed data to the state
                setWorkforceListing(transformedData || []);
            } else {
                setWorkforceListing([]);
            }
        } catch (error) {
            console.error('Error fetching :', error);
            setWorkforceListing([]);
        }
    };



    // FOR GET LIST
    useEffect(() => {
        // fetchSites()
        fetchWorkforce()
        fetchProjects();
    }, []);
    const handleNavigate = () => {
        handleAddEditModal(!isAddEdiModalOpen);
    };

    const formik = useFormik({
        initialValues: {
            siteName: '',
            status: '',
            project: '',
            // subsiteID: '',
            SuperviosrID: '',
            site_location: ''
        },
        // onSubmit: (values) => {
        //     on_change_value(1)
        //     searchFilter(values)
        // },
    });

    const resetFilter = () => {
        formik.resetForm(); // Resets to initial values
        on_page_count_update(25);
        on_change_value(1);

        // Optional: Pass cleared filters to parent
        searchFilter({
            siteName: '',
            status: '',
            project: '',
            SuperviosrID: '',
            site_location: ''
        });
    };
    const breadcrumbs = ['Worksites', tableTitle]

    return (
        <div className="worksite-lookup-search-container">
            <div className="worksite-lookup-search-sub-container">
                <div className="worksite-lookup-search-header">
                    <div className="worksite-lookup-search-left">
                        <div className="worksite-table-title">{tableTitle}</div>
                        <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                    <div className="worksite-lookup-search-right">
                        {isAddPermission && <CustomAddButton label="Add " onClick={handleNavigate} />}
                    </div>
                </div>

                <div className="search-layout-wrapper">
                    <div className="search-filter-container">
                        {/* Search filter section */}
                        <div className="search-inputs-fields">
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    id="site-name"
                                    name="siteName"
                                    placeholder="Search by Site Name"
                                    value={formik.values.siteName}
                                    onChange={formik.handleChange}
                                    width='100%'
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    id="site_location"
                                    name="site_location"
                                    placeholder="Search by Location"
                                    value={formik.values.site_location}
                                    onChange={formik.handleChange}
                                    width='100%'
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="project"
                                    placeholder="Select Project"
                                    options={projectListing}
                                    value={projectListing?.find(option => option?.value === formik?.values?.project) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("project", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    width="200px"
                                    isMulti={false} // Set to false for single-select
                                />
                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomSelectDropdown
                                    name="SuperviosrID"
                                    placeholder="Select Supervisor"
                                    options={workforceListing}
                                    value={workforceListing?.find(option => option?.value === formik?.values?.SuperviosrID) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("SuperviosrID", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    width="200px"
                                    isMulti={false} // Set to false for single-select
                                />

                            </Grid>
                            <Grid item xs={12} sm={6} md={2}>

                                <CustomSelectDropdown
                                    name="status"
                                    placeholder="Select Status"
                                    options={statusOptions}
                                    value={statusOptions?.find(option => option?.value === formik?.values?.status) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("status", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    isDisabled={false}
                                    isMulti={false} // Set to false for single-select
                                    width="200px"
                                />
                            </Grid>
                        </div> {/* Search Button */}
                        <div className="search-buttons-fixed-right">
                            <ActionButton
                                onClick={() => {
                                    on_change_value(1)
                                    searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                                }}
                                btnDisable={false}
                                label="Search"
                                btnType="primary"
                            />
                            <ActionButton label="Reset" btnType="outlined" onClick={resetFilter} />
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default WorksiteSearch;
